import React from 'react';
import './Tab.scss';

export interface TabProps {
  children: React.ReactNode;
  active?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  disabled?: boolean;
  'aria-label'?: string;
  'aria-selected'?: boolean;
}

const Tab: React.FC<TabProps> = ({
  children,
  active = false,
  onClick,
  className = '',
  disabled = false,
  'aria-label': ariaLabel,
  'aria-selected': ariaSelected,
}) => {
  const baseClass = 'tab';
  const activeClass = active ? 'tab--active' : '';
  const disabledClass = disabled ? 'tab--disabled' : '';

  const classes = [
    baseClass,
    activeClass,
    disabledClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-selected={ariaSelected !== undefined ? ariaSelected : active}
      role="tab"
    >
      {children}
    </button>
  );
};

export default Tab;

